/**
 * FilterChip — pill cu text + X button pentru a clear filtrul.
 * Inspired codex-v6 „filter-chip".
 */
interface Props {
  label: string;
  onClear: () => void;
}

export default function FilterChip({ label, onClear }: Props) {
  return (
    <span
      className="inline-flex items-center gap-1.5 font-mono rounded-full"
      style={{
        fontSize: 11,
        padding: '4px 4px 4px 10px',
        color: 'var(--accent)',
        background: 'var(--accent-bg)',
        border: '1px solid var(--accent)',
      }}
    >
      <span>{label}</span>
      <button
        type="button"
        onClick={onClear}
        className="w-4 h-4 rounded-full grid place-items-center transition-colors"
        style={{ color: 'var(--accent)' }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'var(--accent)';
          e.currentTarget.style.color = 'var(--bg-elevated)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = 'var(--accent)';
        }}
        aria-label={`Clear ${label}`}
      >
        <svg
          viewBox="0 0 24 24"
          width="10"
          height="10"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        >
          <path d="M6 6l12 12M6 18L18 6" />
        </svg>
      </button>
    </span>
  );
}
